import * as t from 'io-ts';

import {RActivityIdRef} from './activityModel';
import {makeEnumRuntimeType, RConversationIdRef} from './apiTypes';
import {parseTopic, RTopic} from './topicModel';

/*
 * Constants.
 */

export enum CommentUnfurlTypesEnum {
  CONVERSATION = 'conversation',
  MESSAGE = 'message',
  TOPIC = 'topic',
}

export enum CommentUnfurlErrorsEnum {
  NOT_FOUND = 'not_found',
  FORBIDDEN = 'forbidden',
}

/*
 * Runtime type.
 */

const RCommentUnfurlType = makeEnumRuntimeType(CommentUnfurlTypesEnum);
const RCommentUnfurlError = makeEnumRuntimeType(CommentUnfurlErrorsEnum);

const RBaseCommentUnfurl = t.intersection([
  t.type({
    token: t.string,
    type: RCommentUnfurlType,
  }),
  t.partial({
    conversationId: RConversationIdRef,
    error: RCommentUnfurlError,
  }),
]);

const RConversationCommentUnfurl = t.intersection([
  RBaseCommentUnfurl,
  t.type({
    type: t.literal(CommentUnfurlTypesEnum.CONVERSATION),
  }),
]);

const RMessageCommentUnfurl = t.intersection([
  RBaseCommentUnfurl,
  t.type({
    type: t.literal(CommentUnfurlTypesEnum.MESSAGE),
  }),
  t.partial({
    activityId: RActivityIdRef,
  }),
]);

const RTopicCommentUnfurl = t.intersection([
  RBaseCommentUnfurl,
  t.type({
    type: t.literal(CommentUnfurlTypesEnum.TOPIC),
  }),
  t.partial({
    topic: RTopic,
  }),
]);

export const RCommentUnfurl = t.taggedUnion('type', [
  RConversationCommentUnfurl,
  RMessageCommentUnfurl,
  RTopicCommentUnfurl,
]);

/*
 * Type.
 */

interface ConversationCommentUnfurlModel extends t.TypeOf<typeof RConversationCommentUnfurl> {}
interface MessageCommentUnfurlModel extends t.TypeOf<typeof RMessageCommentUnfurl> {}
export interface TopicCommentUnfurlModel extends t.TypeOf<typeof RTopicCommentUnfurl> {}
export type CommentUnfurlModel =
  | ConversationCommentUnfurlModel
  | MessageCommentUnfurlModel
  | TopicCommentUnfurlModel;

export function parseCommentUnfurl(src: any) {
  return {
    token: src.token,
    error: src.error,
    type: src.type,
    ...(src.conversation && {conversationId: src.conversation.id}),
    ...(src.activity && {conversationId: src.activity.conversation_id, activityId: src.activity.id}),
    ...(src.topic && {topic: parseTopic(src.topic)}),
  };
}
